// extracted by mini-css-extract-plugin
var _1 = "plan-card__addpo";
export { _1 as "planCard" }
